 export const ConfigKeyword = {
  "SHIFT_KEYWORD": "SHIFT_KEYWORD",
  "DATE_KEYWORD": "DATE_KEYWORD",
  "OVERTIME_KEYWORD": "OVERTIME_KEYWORD",
  "MISSION_KEYWORD": "MISSION_KEYWORD",
  "HOURLY_LEAVE_KEYWORD": "HOURLY_LEAVE_KEYWORD",

  "MONTHLY_APPLICATION_KEYWORD": "MONTHLY_APPLICATION_KEYWORD",
  "CHECK_INOUT_KEYWORD": "CHECK_IN/OUT_KEYWORD",
  "KEYWORD": "KEYWORD",
}